// extracted by mini-css-extract-plugin
export default {"adminstudent":"ManagerHome_adminstudent__39GTZ"};